import { render, staticRenderFns } from "./SaildroneDashboardWidget.vue?vue&type=template&id=fb8c8cfe&scoped=true"
import script from "./SaildroneDashboardWidget.vue?vue&type=script&lang=js"
export * from "./SaildroneDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./SaildroneDashboardWidget.vue?vue&type=style&index=0&id=fb8c8cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8c8cfe",
  null
  
)

export default component.exports